import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" style={styles.hero}>
      <div style={styles.overlay}></div>
      <div style={styles.gradientOverlay}></div>
      
      <div style={styles.content} className="hero-content">
        <div style={styles.badge}>
          <Sparkles size={16} style={styles.badgeIcon} />
          <span style={styles.badgeText}>Consulting Premium</span>
        </div>
        
        <div style={styles.textContent}>
          <h1 style={styles.title} className="animate-fade-in hero-title">
            Excellence en
            <br />
            <span style={styles.goldText}>Consulting de Luxe</span>
          </h1>
          <p style={styles.subtitle} className="animate-fade-in hero-subtitle">
            Expertise premium en hospitalité, immobilier et investissements stratégiques. 
            Votre partenaire d'excellence pour des projets d'envergure.
          </p>
          
          <div style={styles.ctaContainer}>
            <button 
              onClick={scrollToContact}
              style={styles.ctaButton}
              className="btn-hover transition-smooth"
            >
              <span>Prendre Rendez-vous</span>
              <ArrowRight size={20} />
            </button>
            
            <div style={styles.stats} className="hero-stats">
              <div style={styles.statItem}>
                <span style={styles.statNumber}>3+</span>
                <span style={styles.statLabel}>Années</span>
              </div>
              <div style={styles.statDivider}></div>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>20+</span>
                <span style={styles.statLabel}>Projets</span>
              </div>
              <div style={styles.statDivider}></div>
              <div style={styles.statItem}>
                <span style={styles.statNumber}>100M€+</span>
                <span style={styles.statLabel}>Valeur</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
    overflow: 'hidden',
    paddingTop: '80px',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(circle at 30% 50%, rgba(212, 175, 55, 0.15) 0%, transparent 50%)',
    pointerEvents: 'none',
  },
  gradientOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(circle at 70% 30%, rgba(212, 175, 55, 0.08) 0%, transparent 60%)',
    pointerEvents: 'none',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 40px',
    width: '100%',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 20px',
    background: 'rgba(212, 175, 55, 0.1)',
    border: '1px solid rgba(212, 175, 55, 0.3)',
    borderRadius: '100px',
    marginBottom: '32px',
  },
  badgeIcon: {
    color: '#D4AF37',
  },
  badgeText: {
    color: '#D4AF37',
    fontSize: '14px',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  textContent: {
    maxWidth: '900px',
  },
  title: {
    fontSize: '72px',
    fontWeight: '700',
    lineHeight: '1.1',
    color: '#FFFFFF',
    marginBottom: '32px',
    letterSpacing: '-0.02em',
  },
  goldText: {
    color: '#D4AF37',
    display: 'inline-block',
    background: 'linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: {
    fontSize: '22px',
    fontWeight: '400',
    lineHeight: '1.6',
    color: 'rgba(255, 255, 255, 0.85)',
    marginBottom: '48px',
    maxWidth: '700px',
  },
  ctaContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '48px',
    flexWrap: 'wrap',
  },
  ctaButton: {
    background: '#D4AF37',
    color: '#000000',
    border: 'none',
    borderRadius: '0px',
    padding: '20px 40px',
    fontSize: '18px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
    transition: 'all 0.4s ease-in-out',
  },
  stats: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  },
  statItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  statNumber: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#D4AF37',
    lineHeight: '1',
  },
  statLabel: {
    fontSize: '12px',
    color: 'rgba(255, 255, 255, 0.6)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  statDivider: {
    width: '1px',
    height: '40px',
    background: 'rgba(212, 175, 55, 0.3)',
  },
};

// Add responsive styles
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @media (max-width: 768px) {
    .hero-title {
      font-size: 42px !important;
    }
    .hero-subtitle {
      font-size: 18px !important;
    }
    .hero-content {
      padding: 0 20px !important;
    }
    .hero-stats {
      justify-content: space-between !important;
      width: 100% !important;
    }
  }
`;
document.head.appendChild(styleSheet);